import { Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import useApi from "../../../../../../hooks/useQuery";
import { ADD_NEW_PRODUCT, GET_REMAINING_PRODUCTS_OFFERERD } from "../../../GraphQLQueries/ProductOffering";
import useMutationApi from "../../../../../../hooks/useMutation";
import { toast } from "react-toastify";
import { LoadingSpinner } from "../../../../../../_ePulse/layout/components/LoadingSpinner";
import { ToastMessageContainer } from "../../../../../../_ePulse/layout/components/ToastMessageContainer";

interface ProductsModelProps {
  onClose: () => void;
  refetch: () => void;
}

export const ProductsModel = (props: ProductsModelProps) => {
  const {
    loading: loadingMedicine,
    data: productData,
  } = useApi("", GET_REMAINING_PRODUCTS_OFFERERD, {});

  const { createData, loading: mutationLoading } = useMutationApi(ADD_NEW_PRODUCT);

  const [selectedData, setSelectedData] = useState<any[]>([]);

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (productData && productData.getBusinessInActiveProductOffering) {
      const newData = productData.getBusinessInActiveProductOffering.map((data: any) => ({
        label: data?.productName,
        value: data?.productValue,
        id: data?.id,
        isSelected: data?.isActive || false
      }));
      setSelectedData(newData);
      // Reset dirty flag when fresh data loads
      setIsDirty(false);
    }
  }, [productData]);

  const handleCheckboxChange = (productId: string) => {
    setIsDirty(true); // User interacted, show the button
    setSelectedData(prevState =>
      prevState.map((item: any) =>
        item.id === productId ? { ...item, isSelected: !item.isSelected } : item
      )
    );
  };

  const AddProductApiCall = async () => {
    const filtered = selectedData?.filter((data: any) => data?.isSelected === true);

    if (filtered.length === 0) {
      toast.error("Please select at least one product.");
      return;
    }

    const newProductInput = filtered?.map((data: any) => ({
      productName: data?.label,
      productValue: data?.value,
      productId: data?.id,
    }));

    try {
      await createData({
        productInput: newProductInput
      });
      toast.success("Product List updated successfully!");
      props.refetch();
      props.onClose();
    } catch (error) {
      toast.error("Error in adding product!");
      console.error("Error creating product:", error);
    }
  };

  return (
    <Modal
      show={true}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.onClose()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <span className='fs-3 fw-bold'>Select Product</span>
      </Modal.Header>
      
      <div className='ePulse-modal-content'>
        <div className='modal-body'>
          <LoadingSpinner isLoading={loadingMedicine || mutationLoading} />
          <ToastMessageContainer />

          {selectedData.length > 0 ? (
            <div className="checkbox-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {selectedData.map((product: any) => (
                <div key={product.id} className="d-flex justify-content-between align-items-center border p-3 mb-2 rounded bg-white">
                  <span className="h5 mb-0">{product.label}</span>
                  <div>
                    <input
                      type="checkbox"
                      style={{  cursor: 'pointer' }}
                      id={product.id}
                      checked={product.isSelected}
                      onChange={() => handleCheckboxChange(product.id)}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center p-4">
              {loadingMedicine ? "Fetching products..." : "No products available to add."}
            </div>
          )}
        </div>
        {isDirty && (
          <div  className='btn-row'>
            <button 
              className='ePulse-btn-primary' 
              type='button' 
              onClick={AddProductApiCall}
              disabled={mutationLoading}
            >
              Continue
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};